import { Address, CreateAddress, UpdateAddress } from "../../../address/types/models/Address";
import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Providers


export interface Provider {
    id: ID;

    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    swift?: string;

    
    addressIdAddress?: Address;
    

    
    scopeGroupId: ID;

    }




export interface CreateProvider {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    swift?: string;

    
    addressIdAddress?: CreateAddress;
    

    
    }


export interface UpdateProvider {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    swift?: string;

    
    addressIdAddress?: UpdateAddress;
    

    
    }

export interface PresentationProviderRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

/**
 * The numbers of a provider, for the rows of the provider list.
 */
export interface ProviderSummary {
    providerId: ID,
    totalCuttings: number,
    activeCuttings: number,
    logsCount: number,
    logsVolume: number,
    cordwoodVolume: number,
    shippedVolume: number,
    stockVolume: number,
}

export interface ProviderSummaryRequest {
    ids: ID[],
}

export class PrimaryProvider {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Provider): PrimaryProvider | undefined {
        return entity ? new PrimaryProvider(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryProvider {
        return new PrimaryProvider(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryProvider {
        let vals = path?.split('/');
        return new PrimaryProvider(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryProvider[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Provider): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityProvider {
    id: PrimaryProvider;
    data: UpdateProvider;


    constructor(id: PrimaryProvider, data: UpdateProvider) {
        this.id = id;
        this.data = data;
    }
}
